import gql from 'graphql-tag';

export default gql`
    mutation UpdateBoxWeight($input: UpdateBoxWeightInput) {
        updateBoxWeight(input: $input) {
            errors
        }
    }
`;
